module.exports = __webpack_public_path__ + "img/yes.c63f19f2.png";